<template>
    <b-modal
        v-model="showWelcomePanel"
        size="lg"
        @shown="$_onStart"
        header-class="custom-modal-header"
        content-class="custom-modal-content"
        dialog-class="custom-modal-dialog-msgfeed"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        @close="$_close"
    >
        <template v-slot:modal-header="{ close }">
            <h3 class="panel-header-title">
                {{ title }}
            </h3>
            <icon-close
                :id="'msgFeed-close'"
                @close="close"
                class="d-inline-block float-right"
            ></icon-close>
        </template>
        <div @cancel="msgShow = false">
            <div id="welcomeMessage" class="welcome-message-body" v-html="welcomeMessage"></div>
            <!-- Niet meer tonen -->
            <b-row>
                <b-col>
                    <XCheckbox
                        class="mt-4 ml-2"
                        name="niet-meer-tonen"
                        :text="$t('labelDontShowAgain')"
                        :value="dontShowAgain"
                        @input="$_toggleDontShowAgain"
                    >
                    </XCheckbox>
                </b-col>
                <b-col>
                    <b-button
                        type="button"
                        variant="primary"
                        class="mt-3 float-right button-close"
                        @click="$_close"
                    >
                        {{ $t('btnCloseLabel') }}
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </b-modal>
</template>
<script>
    import { mapState, mapMutations } from 'vuex';
    import { INTERFACE_PANEL_TRIGGERS } from '../../../../constants';
    import IconClose from '../../../IconClose.vue';

    export default {
        name: 'showWelcomeMessage',
        components: { 'icon-close': IconClose },
        data: function () {
            return {
                welcomeMessage: '',
                showWelcome: false,
                dontShowAgain: false,
                title: 'Welkom'
            };
        },
        computed: {
            ...mapState(['uiElements']),
            welcomeMessagePanel() {
                return this.uiElements[INTERFACE_PANEL_TRIGGERS.WELCOME_PANEL];
            },
            visible() {
                return this.welcomeMessagePanel.visible;
            },
            welcomeMessageData() {
                return this.welcomeMessagePanel.data;
            },
            showWelcomePanel() {
                return this.showWelcome;
            }
        },
        watch: {
            visible(newValue) {
                this.showWelcome = newValue;
            },
            showWelcome(newValue) {
            },
            welcomeMessageData(newValue, oldValue) {
                if (this.showWelcome) {
                    this.$_onStart();
                }
            }
        },
        methods: {
            ...mapMutations([
                'TOGGLE_WELCOME_PANEL',
                'UPDATE_WELCOME_PANEL'
            ]),
            async $_onStart() {
                let data = this.welcomeMessageData;
                if (!data) {
                    return;
                }
                this.title = data.title ?? this.title;
                this.welcomeMessage = data.message ?? this.$t('NoWelcomeMessage');
                this.dontShowAgain = this.welcomeMessagePanel.dontShowAgain;
            },
            async $_close() {
                // save setting by panel
                this.TOGGLE_WELCOME_PANEL(false);
                // save setting in local_storage
                this.UPDATE_WELCOME_PANEL(this.dontShowAgain);
            },
            $_toggleDontShowAgain(newVal) {
                this.dontShowAgain = newVal;
            }
        }
    };
</script>
<style>
@media (min-width: 768px) and (max-width: 990px) {
    .custom-modal-dialog-msgfeed {
        max-width: 600px;
    }
}
</style>

<style lang="scss">
.welcome-message-body {
    p {
        margin-bottom: 0 !important;
        font-family: Helvetica, Arial, sans-serif;
    }
    ol {
        margin-bottom: 0 !important;
        font-family: Helvetica, Arial, sans-serif;
    }
}
</style>

<style scoped lang="scss">
.msgFeed-body {
    text-align: left;
    height: 500px;
    overflow-y: auto;
}
.button-close {
    margin-right: 20px;
}
</style>
